// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3dm7B","alertIcon":"ConfirmModal_alertIcon__3L8K6"};